// extracted by mini-css-extract-plugin
export default {"tableFooter":"availablePackage_tableFooter__fDv8o"};